<template>
  <div>
    <v-sheet class="barra-encaminhamento-lote" elevation="8" rounded>
      <span class="body-2 font-weight-medium mr-4">
        {{ erros.length }} {{ erros.length === 1 ? 'item selecionado' : 'itens selecionados' }}
      </span>
      <v-btn class="mr-2" outlined @click="$emit('limpar')">Limpar</v-btn>
      <v-btn color="primary" @click="abrir">Encaminhar em lote</v-btn>
    </v-sheet>

    <v-dialog v-model="dialog" max-width="920" persistent>
      <v-card>
        <div class="align-center d-flex justify-space-between pb-0 pt-6 px-6">
          <div>
            <h2 class="font-weight-medium ma-0 text-h6">Encaminhar em lote</h2>
            <div class="body-2 grey--text mt-1 text--darken-1">{{ erros.length }} erros selecionados</div>
          </div>
          <div>
            <v-btn aria-label="Fechar encaminhamento em lote" icon :disabled="processando" @click="fechar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-card-text class="pa-0">
          <v-alert v-if="quantidadeAguardandoValidacao && !falhas.length" class="mb-0 mt-4 mx-5" dense outlined type="info">
            {{ quantidadeAguardandoValidacao }}
            {{
              quantidadeAguardandoValidacao === 1
                ? 'erro aguardando validação será encaminhado'
                : 'erros aguardando validação serão encaminhados'
            }}
            para Analisar primeiro, mesmo que outro fluxo seja escolhido.
          </v-alert>

          <encaminhar-tarefa
            v-if="!falhas.length"
            :key="chaveFormulario"
            em-lote
            :erro="erroDoFormulario"
            :processando="processando"
            :tarefa="tarefaDoFormulario"
            @confirmar="confirmar"
          />

          <div v-else class="px-4 py-2">
            <v-alert class="mb-4" dense outlined type="warning">
              {{ sucessos }} de {{ totalProcessado }} erros foram encaminhados. Os itens abaixo não foram encaminhados.
            </v-alert>
            <v-list dense>
              <v-list-item v-for="falha in falhas" :key="falha.erro_id" class="px-0">
                <v-list-item-content>
                  <v-list-item-title>{{ falha.rotulo }}</v-list-item-title>
                  <v-list-item-subtitle>{{ falha.mensagem }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div class="d-flex justify-end pb-4">
              <v-btn color="primary" @click="fechar">Fechar</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import GestaoBdgdsErrosTarefasService from '@/services/GestaoBdgdsErrosTarefasService.js';
  import EncaminharTarefa from './EncaminharTarefa.vue';

  export default {
    name: 'BarraEncaminhamentoLote',

    components: { EncaminharTarefa },

    props: {
      erros: {
        type: Array,
        default: () => []
      }
    },

    data() {
      return {
        dialog: false,
        processando: false,
        falhas: [],
        sucessos: 0,
        totalProcessado: 0,
        chaveFormulario: 0,
        tarefaDoFormulario: { id: null }
      };
    },

    computed: {
      quantidadeAguardandoValidacao() {
        return this.erros.filter((erro) => erro.status_erro === 'AGUARDANDO_VALIDACAO').length;
      },

      erroDoFormulario() {
        const todosAguardando = this.erros.length > 0 && this.quantidadeAguardandoValidacao === this.erros.length;

        return { id: null, status_erro: todosAguardando ? 'AGUARDANDO_VALIDACAO' : 'IDENTIFICADO' };
      }
    },

    methods: {
      abrir() {
        this.falhas = [];
        this.sucessos = 0;
        this.chaveFormulario += 1;
        this.dialog = true;
      },

      fechar() {
        if (this.processando) return;

        const limparSelecao = this.falhas.length > 0;

        this.dialog = false;
        this.falhas = [];

        if (limparSelecao) this.$emit('limpar');
      },

      rotuloErro(erro) {
        return [erro.entidade, erro.nome_validacao, erro.campo].filter(Boolean).join(' · ') || `Erro #${erro.id}`;
      },

      async confirmar(dados) {
        if (this.processando) return;

        this.processando = true;
        this.totalProcessado = this.erros.length;

        try {
          const { data } = await GestaoBdgdsErrosTarefasService.encaminharTarefasEmLote({
            ...dados,
            erro_ids: this.erros.map((erro) => erro.id)
          });
          const resultados = data.data?.resultados || [];
          const errosPorId = new Map(this.erros.map((erro) => [erro.id, erro]));

          this.sucessos = resultados.filter((resultado) => resultado.sucesso).length;
          this.falhas = resultados
            .filter((resultado) => !resultado.sucesso)
            .map((resultado) => ({
              erro_id: resultado.erro_id,
              rotulo: this.rotuloErro(errosPorId.get(resultado.erro_id) || { id: resultado.erro_id }),
              mensagem: resultado.mensagem || 'Não foi possível encaminhar este erro.'
            }));

          this.$emit('concluido');

          if (!this.falhas.length) {
            this.$toast.success(this.sucessos === 1 ? '1 erro encaminhado.' : `${this.sucessos} erros encaminhados.`, '', {
              position: 'topRight'
            });
            this.dialog = false;
            this.$emit('limpar');
          }
        } catch (error) {
          this.$toast.error(error?.response?.data?.message || 'Não foi possível encaminhar os erros selecionados.', '', {
            position: 'topRight'
          });
        } finally {
          this.processando = false;
        }
      }
    }
  };
</script>

<style scoped>
  .barra-encaminhamento-lote {
    position: fixed;
    z-index: 8;
    left: 50%;
    bottom: 24px;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    padding: 12px 16px;
  }
</style>
